// extracted by mini-css-extract-plugin
var _1 = "CommentWarning-module__animatedBackground--mxRLJ";
var _2 = "CommentWarning-module__container--mzrT4";
var _3 = "CommentWarning-module__content--FhGam";
var _4 = "CommentWarning-module__icon--_ne1p";
export { _1 as "animatedBackground", _2 as "container", _3 as "content", _4 as "icon" }
